import { render, staticRenderFns } from "./GlowingSphere.vue?vue&type=template&id=6828213d&scoped=true&"
import script from "./GlowingSphere.vue?vue&type=script&lang=js&"
export * from "./GlowingSphere.vue?vue&type=script&lang=js&"
import style0 from "./GlowingSphere.vue?vue&type=style&index=0&id=6828213d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828213d",
  null
  
)

export default component.exports